import { useSelector } from 'react-redux'
import './licensesSectionStyles.scss'
import classNames from 'classnames'
import { AccountSettingsSection } from '../AccountSettingsSection/AccountSettingsSection'
import { text } from './constants'
import { LicenseInfoCard } from './components/LicensesInfoCard/LicenseInfoCard'

export const LicensesSection = () => {
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const licensesList = useSelector((state) => state.waitingRoomReducer.providerProfile.Licenses)

  return (
    // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
    <AccountSettingsSection
      className={classNames('licenses-section-main-wrapper', {
        ['licenses-section-main-wrapper-with-licenses']: licensesList?.length,
      })}
      title={text.LICENSES}
      isWithLockIcon>
      {licensesList?.length ?
        <div className='licenses-section-content-container'>
          {/*
           // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered */}
          {licensesList.map((license) => (
            <LicenseInfoCard licenseInfo={license} />
          ))}
        </div>
      : <div className='licenses-section-text'>{text.NO_LICENSES_ADDED}</div>}
    </AccountSettingsSection>
  )
}
